import { useToast } from 'vue-toast-notification';
import EventBusGlobal, { GlobalEventName } from '@/commons/eventBusGlobal';

import { ModuleBackupDatabase } from '@/stores/moduleConst';
import i18nBaseForm from '@/i18ns/vi/i18nBaseForm';
import router from '@/routers/router';
import commonFn from '@/commons/commonFunction';
import { showAlertEscapsed } from '@/commons/globalMessage';
import { ModuleContext } from '@/stores/moduleConst';
import { MSConstant } from '@/commons/wildcards';

export const useBackupCommon = () => {
  /**
   * Hàm convert ra phiên bản
   */
  function convertVersion(dbVersion) {
    if (!dbVersion) {
      return '';
    }

    let ver = dbVersion.split('.');

    if (ver.length != 4) {
      return dbVersion;
    }

    let prefix = '';
    let suffix = '';

    if (ver[0] == 0 && ver[1] == 0 && ver[2] == 0 && ver[3] != 0) {
      if (ver[3] <= 999) {
        prefix = 'DEV';
      }
      if (ver[3] > 999) {
        prefix = 'Alpha';
        suffix = Math.min(ver[3] / 1000, 3);
      }
    }

    if (ver[0] == 0 && ver[1] == 0 && ver[2] != 0) {
      prefix = 'Beta';
      suffix = ver[2];
    }

    if (ver[0] == 0 && ver[1] != 0) {
      prefix = 'RC';
      suffix = ver[1];
    }

    if (ver[0] != 0) {
      prefix = 'R';
      suffix = ver[0];
    }

    return prefix + suffix;
  }

  /**
   * Chuyển kiểu size
   * @param {*} bytes
   * @param {*} decimals
   * @returns
   */
  function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  /**
   * Sau khi restore thành công
   */
  function afterRestoreSuccess(model) {
    EventBusGlobal.$emit(GlobalEventName.loadDatabase);
    EventBusGlobal.$emit(GlobalEventName.loadDatabaseManagement);
  }

  /**
   * Thực hiện sao lưu
   */
  function afterBackup() {
    EventBusGlobal.$emit(GlobalEventName.loadDatabaseManagement);
  }

  /**
   * Sau khi backup thành công
   * ntloc 29/05/2023: bổ sung thêm trường hợp sao lưu cho thông tư 23
   */
  function afterBackupSuccess(context, state, payload) {
    const toast = useToast();

    let tenantId = state.Context.TenantId;
    let databaseId = state.Context.DatabaseId;
    // Nếu là đang chuyển đổi thì nvtoan2 xử lý khác
    // nvtoan2 17/10/2023
    if (!state.DatabaseConverting.some(x => x == databaseId)) {
      if (payload.is_success && (payload.circular != 'tt23' || payload.circular == undefined)) {
        context.dispatch(
          `${ModuleBackupDatabase}/load`,
          { tenant_id: tenantId, database_id: databaseId },
          { root: true }
        );
        switch (payload.type) {
          case MSConstant.BackupType.Store:
            router.push('/dictionary/datamanagement/storage');
            break;
          default:
            router.push('/dictionary/datamanagement/backup');
            break;
        }
      } else if (payload.is_success && payload.circular == 'tt23') {
        commonFn.unmask();
        showAlertEscapsed(
          proxy.$tm('i18nBaseForm.Message.CloneDataSuccess'),
          [payload.database_name],
          'Sao lưu dữ liệu thành công'
        ).then(res => {
          context.dispatch(`updateBackUpSuccess`, true);
        });
      } else {
        toast.error(i18nBaseForm.Message.Exception, { position: 'top' });
      }
    }

  }

  /**
   * Sau khi hủy backup
   */
  function afterCancelBackup(context, state, payload) {
    const toast = useToast();

    let tenantId = state.Context.TenantId;
    let databaseId = state.Context.DatabaseId;
    if (payload.is_success) {
      context
        .dispatch(`${ModuleBackupDatabase}/load`, { tenant_id: tenantId, database_id: databaseId }, { root: true })
        .then(() => {
          toast.success('Đã hủy sao lưu dữ liệu', {
            position: 'top'
          });
        });
    } else {
      toast.error(i18nBaseForm.Message.Exception, {
        position: 'top'
      });
    }
  }

  return {
    convertVersion,
    formatBytes,
    afterRestoreSuccess,
    afterBackupSuccess,
    afterCancelBackup,
    afterBackup
  };
};
